export const months = [
    {
        id : 'January', 
        value: 'January',
        price: 0
    },
    {
        id : 'February', 
        value: 'February',
        price: 0
    },
    {
        id : 'March', 
        value: 'March',
        price: 0
    },
    {
        id : 'April', 
        value: 'April',
        price: 0
    },
    {
        id : 'May', 
        value: 'May',
        price: 0
    },
    {
        id : 'June', 
        value: 'June',
        price: 0
    },
    {
        id : 'July', 
        value: 'July',
        price: 0
    },
    {
        id : 'August', 
        value: 'August',
        price: 0
    },
    {
        id : 'September', 
        value: 'September',
        price: 0
    },
    {
        id : 'October', 
        value: 'October',
        price: 0
    },
    {
        id : 'November', 
        value: 'November',
        price: 0
    },
    {
        id : 'December', 
        value: 'December',
        price: 0
    },
]